import React from 'react';
import { Grid } from '@mui/material';

import { Company } from '../../../models/company.model';
import { Customer } from '../../../models/customer.model';
import CustomerDetailsCard from '../../../common/customer-details-card/CustomerDetailsCard';

interface DetailsTabsProps {
  company: Company;
  customer: Customer;
  key: string;
}

const DetailsTabs: React.FC<DetailsTabsProps> = ({ customer }) => {
  return (
    <>
      <Grid container wrap='wrap' rowGap={2}>
        <Grid size={{ xs: 12 }}>
          <CustomerDetailsCard customer={customer} />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <CustomerDetailsCard simplified preferences customer={customer} />
        </Grid>

        {/* <Grid size={{xs: 12}}>
          <EmploymentCard employee={customer} />
        </Grid>

        <Grid size={{xs: 12}}>
          <QualificationsCard employee={customer} />
        </Grid>

        <Grid size={{xs: 12}}>
          <EmergencyContactCard employee={customer} />
        </Grid> */}
      </Grid>
    </>
  );
};

export default DetailsTabs;
